import * as Type from 'library/ts/utilities/modules/Type';
export const difference = (dateFrom, dateTo) => {
    if (Type.isUndefined(dateFrom) && Type.isUndefined(dateTo))
        return null;
    let tempFromDate;
    let tempToDate;
    if (dateFrom > dateTo) {
        tempFromDate = new Date(dateTo.getTime());
        tempToDate = new Date(dateFrom.getTime());
        dateFrom = tempFromDate;
        dateTo = tempToDate;
    }
    const from = {
        d: dateFrom.getDate(),
        m: dateFrom.getMonth() + 1,
        y: dateFrom.getFullYear()
    };
    const to = {
        d: dateTo.getDate(),
        m: dateTo.getMonth() + 1,
        y: dateTo.getFullYear()
    };
    const daysFebruary = to.y % 4 !== 0 || (to.y % 100 === 0 && to.y % 400 !== 0) ? 28 : 29;
    const daysInMonths = [0, 31, daysFebruary, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (to.d < from.d) {
        to.d += daysInMonths[to.m];
        from.m += 1;
    }
    if (to.m < from.m) {
        to.m += 12;
        from.y += 1;
    }
    const diffMilliseconds = (dateTo.getTime() - dateFrom.getTime());
    const diffSeconds = Math.round(diffMilliseconds / 1000);
    const diffMinutes = Math.round(((diffMilliseconds % 86400000) % 3600000) / 60000);
    const diffHours = Math.floor((diffMilliseconds % 86400000) / 3600000);
    return {
        ms: diffMilliseconds,
        seconds: diffSeconds,
        minutes: diffMinutes,
        hours: diffHours,
        days: to.d - from.d,
        months: to.m - from.m,
        years: to.y - from.y
    };
};
export const secondsToHHMMSSMS = (timeInSeconds = new Date().getTime() / 1000) => {
    const pad = function (num, size) {
        return ('000' + num).slice(size * -1);
    };
    const time = parseFloat(timeInSeconds.toString()).toFixed(3);
    const hours = Math.floor(parseFloat(time) / 60 / 60);
    const minutes = Math.floor(parseFloat(time) / 60) % 60;
    const seconds = Math.floor(parseFloat(time) - minutes * 60);
    const milliseconds = time.slice(-3);
    return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2) + ',' + pad(milliseconds, 3);
};
